import styled from "styled-components/macro";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdCheckCircle,
  MdImage,
  MdMenu,
  MdPauseCircleFilled,
  MdPlayCircleFilled,
  MdStar,
  MdStarBorder,
} from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import "../styles/Product.css";
import Topnav from "../components/Topnav";
import { useNavigate, useParams } from "react-router";
import Footer from "../components/Footer";
import { isEmpty } from "../functions/isEmpty";
import { formatEuroCents } from "../functions/formatEuroCents";

export default function Product({
  products,
  cart,
  setCart,
  reviews,
  isMobile,
  language,
  setLanguage,
  texts,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [thisProduct, setThisProduct] = useState({});
  const [unit, setUnit] = useState(1);
  const [activeImage, setActiveImage] = useState("");
  const [basicEdition, setBasicEdition] = useState(true);
  const [addedToCart, setAddedToCart] = useState(false); // NEU
  const [showCartButton, setShowCartButton] = useState(false); // NEU

  useEffect(() => {
    products.map((product, index) => {
      if (product.id == id) {
        setThisProduct(product);
        setActiveImage(JSON.parse(product.images)[0]);
      }
    });
  }, [id, products]);

  const handleAddToCart = (product) => {
    setCart((prevCart) => [...prevCart, product]);
    setShowCartButton(true);

    // 4. "addedToCart" für 3 Sekunden true setzen
    setAddedToCart(true); // NEU
    setTimeout(() => {
      setAddedToCart(false);
      console.log(cart);
    }, 1000);
  };

  const removeUnit = () => {
    if (unit <= 1) {
      setUnit(1);
      return;
    } else {
      let num = unit;
      let new_num = num - 1;
      setUnit(new_num);
    }
  };

  const addUnit = (e) => {
    let num = unit;
    let new_num = num + 1;
    setUnit(new_num);
  };

  const handleProductClick = (product) => {
    window.scrollTo(0, 0);
    navigate("/product/" + product.id);
  };

  return (
    <div className="product">
      <Topnav
        cart={cart}
        language={language}
        setLanguage={setLanguage}
        isMobile={isMobile}
      />
      <div className="home_banner">
        {" "}
        {language == "Deutsch" ? texts.de.banner : texts.en.banner}{" "}
      </div>
      <div className="product_section">
        <div className="product_section_hero">
          <div className="product_section_hero_left">
            <div
              className="product_section_hero_left_top"
              onClick={() => navigate("/")}>
              <ArrowBackIcon /> Zurück
            </div>
            <div className="product_section_hero_left_bottom">
              <div className="product_section_hero_left_preview">
                {!isEmpty(thisProduct) &&
                  JSON.parse(thisProduct?.images).map((img, index) => (
                    <div
                      className="product_section_hero_left_preview_box"
                      onClick={() => setActiveImage(img)}>
                      <img
                        src={img}
                        className="product_section_hero_left_preview_box_img"
                      />
                    </div>
                  ))}
              </div>
              <div className="product_section_hero_left_imgbox">
                <img
                  src={activeImage}
                  className="product_section_hero_left_imgbox_img"
                />
              </div>
            </div>
          </div>
          <div className="product_section_hero_right">
            <div className="product_section_hero_right_box">
              <div className="product_section_hero_right_box_title">
                {thisProduct.name}
              </div>
              <div className="product_section_hero_right_box_description">
                {thisProduct.description}
              </div>
              <div className="product_section_hero_right_box_delivery">
                Versandt in 1-2 Werktagen
              </div>
              <div className="product_section_hero_right_versions">
                <div
                  className={
                    basicEdition
                      ? "product_section_hero_right_versions_version_active"
                      : "product_section_hero_right_versions_version"
                  }
                  onClick={() => setBasicEdition(true)}>
                  <img
                    src={
                      !isEmpty(thisProduct) && JSON.parse(thisProduct.images)[0]
                    }
                    className="product_section_hero_right_versions_version_img"
                  />
                  <div className="product_section_hero_right_versions_version_textbox">
                    <div className="product_section_hero_right_versions_version_textbox_top">
                      Basic Edition
                    </div>
                    <div className="product_section_hero_right_versions_version_textbox_bottom"></div>
                  </div>
                  <div className="product_section_hero_right_versions_version_price">
                    {formatEuroCents(thisProduct.price)}
                  </div>
                </div>
                <div
                  className={
                    basicEdition
                      ? "product_section_hero_right_versions_version"
                      : "product_section_hero_right_versions_version_active"
                  }
                  onClick={() => setBasicEdition(false)}>
                  <img
                    src={
                      !isEmpty(thisProduct) && JSON.parse(thisProduct.images)[0]
                    }
                    className="product_section_hero_right_versions_version_img"
                  />{" "}
                  <div className="product_section_hero_right_versions_version_textbox">
                    <div className="product_section_hero_right_versions_version_textbox_top">
                      Limited Edition
                    </div>
                    <div className="product_section_hero_right_versions_version_textbox_bottom"></div>
                  </div>
                  <div className="product_section_hero_right_versions_version_price">
                    {formatEuroCents(thisProduct.price)}
                  </div>
                </div>
              </div>
              <div className="product_section_hero_right_quantitity">
                <div
                  className="product_section_hero_right_quantitity_decrease"
                  onClick={() => removeUnit()}>
                  -
                </div>
                <div className="product_section_hero_right_quantitity_count">
                  {unit}
                </div>
                <div
                  className="product_section_hero_right_quantitity_increase"
                  onClick={() => addUnit()}>
                  +
                </div>
              </div>
              {addedToCart ? (
                <>
                  <div className="product_section_hero_right_cta_added">
                    hinzugefügt... <CheckIcon />
                  </div>
                  {showCartButton && (
                    <div
                      className="product_section_hero_right_toCart"
                      onClick={(e) => navigate("/cart")}>
                      Warenkorb öffnen
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div
                    className="product_section_hero_right_cta"
                    onClick={() => handleAddToCart(thisProduct)}>
                    {language == "English"
                      ? "add to cart"
                      : "Zum Warenkorb hinzufügen"}
                  </div>
                  {showCartButton && (
                    <div
                      className="product_section_hero_right_toCart"
                      onClick={(e) => navigate("/cart")}>
                      Warenkorb öffnen
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {isMobile && (
        <div className="product_section_mobilebox">
          <div className="product_section_hero_right_box_title">
            {thisProduct.name}
          </div>
          <div className="product_section_hero_right_box_description">
            {thisProduct.description}
          </div>
          <div className="product_section_hero_right_box_delivery">
            Versandt in 1-2 Werktagen
          </div>
          <div className="product_section_hero_right_versions">
            <div
              className={
                basicEdition
                  ? "product_section_hero_right_versions_version_active"
                  : "product_section_hero_right_versions_version"
              }
              onClick={() => setBasicEdition(true)}>
              <img
                src={!isEmpty(thisProduct) && JSON.parse(thisProduct.images)[0]}
                className="product_section_hero_right_versions_version_img"
              />
              <div className="product_section_hero_right_versions_version_textbox">
                <div className="product_section_hero_right_versions_version_textbox_top">
                  Basic Edition
                </div>
                <div className="product_section_hero_right_versions_version_textbox_bottom"></div>
              </div>
              <div className="product_section_hero_right_versions_version_price">
                {formatEuroCents(thisProduct.price)}
              </div>
            </div>
            <div
              className={
                basicEdition
                  ? "product_section_hero_right_versions_version"
                  : "product_section_hero_right_versions_version_active"
              }
              onClick={() => setBasicEdition(false)}>
              <img
                src={!isEmpty(thisProduct) && JSON.parse(thisProduct.images)[0]}
                className="product_section_hero_right_versions_version_img"
              />{" "}
              <div className="product_section_hero_right_versions_version_textbox">
                <div className="product_section_hero_right_versions_version_textbox_top">
                  Limited Edition
                </div>
                <div className="product_section_hero_right_versions_version_textbox_bottom"></div>
              </div>
              <div className="product_section_hero_right_versions_version_price">
                {formatEuroCents(thisProduct.price)}
              </div>
            </div>
          </div>
          <div className="product_section_hero_right_quantitity">
            <div
              className="product_section_hero_right_quantitity_decrease"
              onClick={() => removeUnit()}>
              -
            </div>
            <div className="product_section_hero_right_quantitity_count">
              {unit}
            </div>
            <div
              className="product_section_hero_right_quantitity_increase"
              onClick={() => addUnit()}>
              +
            </div>
          </div>
          {addedToCart ? (
            <>
              <div className="product_section_hero_right_cta_added">
                hinzugefügt... <CheckIcon />
              </div>
              {showCartButton && (
                <div
                  className="product_section_hero_right_toCart"
                  onClick={(e) => navigate("/cart")}>
                  Warenkorb öffnen
                </div>
              )}
            </>
          ) : (
            <>
              <div
                className="product_section_hero_right_cta"
                onClick={() => handleAddToCart(thisProduct)}>
                {language == "English"
                  ? "add to cart"
                  : "Zum Warenkorb hinzufügen"}
              </div>
              {showCartButton && (
                <div
                  className="product_section_hero_right_toCart"
                  onClick={(e) => navigate("/cart")}>
                  Warenkorb öffnen
                </div>
              )}
            </>
          )}
        </div>
      )}

      <div className="product_section">
        <div className="product_section_details">
          <div className="product_section_details_title">Details</div>
          <div className="product_section_details_text">
            Aloe Vera Hallo Wie Gehts Hallo Aloe Vera Hallo Wie Gehts Hallo Aloe
            Vera Hallo Wie Gehts Hallo Aloe Vera Hallo Wie Gehts Hallo Aloe Vera
            Hallo Wie Gehts HalloAloe Vera Hallo Wie Gehts Hallo Aloe Vera Hallo
            Wie Gehts Hallo Aloe Vera Hallo Wie Gehts Hallo v Aloe Vera Hallo
            Wie Gehts Hallo Aloe Vera Hallo Wie Gehts Hallo
          </div>
          <div className="product_section_details_image">
            <img
              src="/background.jpg"
              className="product_section_details_image_img"
            />
          </div>
        </div>
      </div>
      <div className="product_section">
        <div className="product_section_reviews">
          <div className="product_section_reviews_title">Bewertungen</div>
          <div className="product_section_reviews_top">
            <div className="product_section_reviews_top_left">
              4,7
              <StarIconLarge />
            </div>
            <div className="product_section_reviews_top_right">
              <div className="product_section_reviews_top_right_top"></div>
              <div className="product_section_reviews_top_right_bottom">
                Einloggen zum Bewerten
              </div>
            </div>
          </div>
          <div className="product_section_reviews_bottom">
            <div className="product_section_reviews_bottom_row">
              <div className="product_section_reviews_bottom_row_element">
                <div className="product_section_reviews_bottom_row_element_left">
                  <img
                    src={"../social_placeholder.jpg"}
                    className="product_section_reviews_bottom_row_element_left_img"
                  />
                </div>
                <div className="product_section_reviews_bottom_row_element_right">
                  <div className="product_section_reviews_bottom_row_element_right_top">
                    <div className="product_section_reviews_bottom_row_element_right_top_left">
                      5<StarIcon /> Rezensent Name
                    </div>
                    <div className="product_section_reviews_bottom_row_element_right_top_right"></div>
                  </div>
                  <div className="product_section_reviews_bottom_row_element_right_bottom">
                    Finde ich gut
                  </div>
                </div>
              </div>
              <div className="product_section_reviews_bottom_row_element">
                <div className="product_section_reviews_bottom_row_element_left">
                  <img
                    src={"../social_placeholder.jpg"}
                    className="product_section_reviews_bottom_row_element_left_img"
                  />
                </div>
                <div className="product_section_reviews_bottom_row_element_right">
                  <div className="product_section_reviews_bottom_row_element_right_top">
                    <div className="product_section_reviews_bottom_row_element_right_top_left">
                      5<StarIcon /> Rezensent Name
                    </div>
                    <div className="product_section_reviews_bottom_row_element_right_top_right"></div>
                  </div>
                  <div className="product_section_reviews_bottom_row_element_right_bottom">
                    Finde ich gut
                  </div>
                </div>
              </div>
            </div>
            <div className="product_section_reviews_bottom_row_loadmore">
              Weitere laden
            </div>
          </div>
        </div>
      </div>
      <div className="product_section">
        <div className="product_section_otherproducts">
          <div className="product_section_otherproducts_title">
            Weitere Produkte
          </div>
          <div className="product_section_otherproducts_row">
            {products.map((product, index) => {
              if (index < 3) {
                return (
                  <div
                    key={product.id}
                    className="product_section_otherproducts_row_element"
                    onClick={() => handleProductClick(product)}>
                    <div className="home_section_products_row_element_imgbox">
                      <img
                        src={JSON.parse(product.images)[0]}
                        className="home_section_products_row_element_imgbox_img"
                      />
                    </div>
                    <div className="home_section_products_row_element_labelbox">
                      <div className="home_section_products_row_element_labelbox_top">
                        <div className="home_section_products_row_element_labelbox_top_left">
                          {" "}
                          {product.name}{" "}
                        </div>
                        <div className="home_section_products_row_element_labelbox_top_right">
                          {" "}
                          {isMobile && formatEuroCents(product.price)}
                        </div>
                      </div>
                      <div className="home_section_products_row_element_labelbox_bottom">
                        <div className="home_section_products_row_element_labelbox_bottom_left">
                          {!isMobile && formatEuroCents(product.price)}
                        </div>
                        <div
                          className="home_section_products_row_element_labelbox_bottom_right"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddToCart(product);
                          }}>
                          {language == "Deutsch"
                            ? texts.de.products_addtocart
                            : texts.en.products_addtocart}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
      <Footer texts={texts} language={language} />
    </div>
  );
}
const PlayIcon = styled(MdPlayCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const PauseIcon = styled(MdPauseCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 20px;
  color: rgb(0, 119, 155);
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 20px;
  color: rgb(0, 119, 155);
`;

const StarIcon = styled(MdStar)`
  font-size: 16px;
  color: #008793;
  margin-bottom: -3px;
`;

const StarIconLarge = styled(MdStar)`
  font-size: 36px;
  color: #008793;
  margin-bottom: -5px;
`;
